/* eslint-disable */

//import axios from "axios";

//const url = require("../../client_config/config").url;

const state = {
  saveDialog: false,
  allowAccessAction: [
    'Administration',
    'Shift Lead',
    'Assistant Manager',
    'House Manager',
    'Program Manager',
    'Client Services Manager',
    'Medical Manager',
    'Executive Director',
    'Finance Manager',
    'Compliance Manager',
    "Human Resources",
    "Program Coordinator"
  ],
  timeSheet: {},
};

const getters = { };

const actions = { };

const mutations = {
  SET_SAVE_DIALOG(state, data) {
    state.saveDialog = data;
  },
  SET_TIMESHEET(state, data) {
    state.timeSheet = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
